import type { HtmlAttributes } from '@studio/design-system/props';
import type { Device } from '@studio/models/device';
import type { PTZ } from '@studio/models/ptz';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { T_Optional } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import { Navipad } from '#~/control/components/editor/index.js';
import { move } from '#~/control/movement/commands/index.js';

/** `<Controller>` component. */
export const Controller = ({
  deviceId,
  ...props
}: HtmlAttributes<T_Optional<{ deviceId: Device['id'] }>>): ReactElement => {
  const handleMove = useLatestFn((intent: PTZ) => {
    if (deviceId) {
      move(deviceId, intent);
    }
  });

  return <Navipad {...props} deviceId={deviceId!} disabled={!deviceId} onMove={handleMove} />;
};
